import React from 'react';
import { connect } from 'react-redux';
import { saveScrollPosition } from '../reducers/scroll';

class ScrollManager extends React.Component {
    _isRestoring = false;
    _restoreTimeout = null;
    _restoreRetryTimeout = null;
    _restoreAttempts = 0;
    _maxRestoreAttempts = 8;

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);

        // Initial restore
        if (this.props.ready) {
            this.restoreScroll();
        }

        // Restore again after paint (helps async content)
        this._restoreTimeout = setTimeout(() => {
            if (this.props.ready) {
                this.restoreScroll();
            }
        }, 0);
    }

    componentDidUpdate(prevProps) {
        // If page finished loading async content, restore again
        if (prevProps.ready !== this.props.ready && this.props.ready) {
            this._restoreAttempts = 0;
            this.restoreScroll();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        clearTimeout(this._restoreTimeout);
        clearTimeout(this._restoreRetryTimeout);
    }

    handleScroll = () => {
        if (this._isRestoring || !this.props.ready) return;

        const { routeKey, saveScrollPosition } = this.props;
        saveScrollPosition(routeKey, window.pageYOffset);
    };

    restoreScroll = () => {
        const { routeKey, scrollPositions } = this.props;
        const saved = scrollPositions[routeKey];

        if (saved !== undefined) {
            this._isRestoring = true;
            window.scrollTo(0, saved);

            // Let browser settle before re-enabling capture
            requestAnimationFrame(() => {
                this._isRestoring = false;
            });

            // If the page height is still settling, retry a few times.
            if (this.props.ready && window.pageYOffset < saved && this._restoreAttempts < this._maxRestoreAttempts) {
                this._restoreAttempts += 1;
                clearTimeout(this._restoreRetryTimeout);
                this._restoreRetryTimeout = setTimeout(this.restoreScroll, 50);
            }
        }
    };

    render() {
        return null;
    }
}

const mapStateToProps = state => ({
    scrollPositions: state.scroll
});

export default connect(
    mapStateToProps,
    { saveScrollPosition }
)(ScrollManager);
